export default __webpack_public_path__ + "98c975842ac98b83522f39d590807d4b.mp3";